import { ImageWithLoading } from "../../../components/ImageWithLoading";
import { mergeClass } from "../../../utils";
import {
  Border,
  DivWFHF,
  IPreviewProps,
  WaveImage,
  getTextSlideData,
} from "./utils";
import parse from "html-react-parser";

const PortraitImage = ({ itemData }: IPreviewProps) => {
  const { bgColor } = getTextSlideData(itemData);
  console.log("itemData", itemData);
  return (
    <DivWFHF className="grid flex" style={{ backgroundColor: bgColor }}>
      {itemData && (itemData.videoThumbnail || itemData.imageUrl) ? (
        <img
          className="w-full h-full object-cover"
          src={itemData.videoThumbnail || itemData.imageUrl}
        />
      ) : (
        <div className="w-full text-center place-self-center text-darkGrayBg">
          Upload image / video for preview
        </div>
      )}
    </DivWFHF>
  );
};

const PortraitText = ({ itemData }: IPreviewProps) => {
  const { bgColor, pictogram, darkBg } = getTextSlideData(itemData);
  return (
    <div
      className={mergeClass(
        "relative w-full h-full grid grid-rows-3 text-left",
        {
          "text-white": darkBg,
        }
      )}
      style={{ backgroundColor: bgColor }}
    >
      <div
        className={mergeClass(
          "row-span-2 w-full h-full grid content-center font-bold",
          "pl-[1.05rem] pr-[0.3rem] text-[1.08rem] leading-[1.43rem]"
        )}
      >
        {itemData.message || (
          <span className="font-thin text-lg text-darkGrayBg">
            Enter a message
          </span>
        )}
      </div>
      <div className="absolute bottom-0 right-0">
        {pictogram && (
          <img
            src={`/assets/pictograms/${pictogram}`}
            className={mergeClass("w-28 h-28 filter", {
              "brightness-0": !darkBg,
            })}
          />
        )}
      </div>
    </div>
  );
};

const PortraitTextAndImage = ({
  itemData,
  reverse,
}: IPreviewProps & { reverse: boolean }) => {
  const { bgColor, hasTitle, darkBg } = getTextSlideData(itemData);
  return (
    <div className="w-full h-full" style={{ backgroundColor: bgColor }}>
      <div className="w-full h-full grid grid-rows-2">
        <div
          className={mergeClass(
            "relative pt-[2.55rem] pl-[1.38rem] pr-[1.25rem] text-left",
            {
              "order-last": reverse,
              "text-white": darkBg,
            }
          )}
        >
          <WaveImage darkBg={darkBg} className="w-12" />
          {hasTitle && (
            <div className="text-[0.857rem] leading-[0.98rem] mb-1.5 font-bold">
              {itemData.title}
            </div>
          )}
          {itemData.subheading && itemData.subheading.length > 0 && (
            <div className="text-[0.517rem] mb-0.5">{itemData.subheading}</div>
          )}
          {itemData.caption && itemData.caption.length > 0 ? (
            <DivWFHF className="text-[0.47rem] leading-[0.63rem]">
              {parse(itemData.caption)}
            </DivWFHF>
          ) : (
            <span className="font-thin text-lg text-darkGrayBg">
              Add a caption
            </span>
          )}
        </div>
        {itemData && (itemData.videoThumbnail || itemData.imageUrl) ? (
          <div className="h-full overflow-hidden">
            <ImageWithLoading
              className="w-full h-full object-cover"
              src={itemData.videoThumbnail || itemData.imageUrl}
            />
          </div>
        ) : (
          <div className="w-full h-full grid content-center text-center text-darkGrayBg bg-white/30">
            Upload image / video for preview
          </div>
        )}
      </div>
    </div>
  );
};

const PortraitTextAndImageForward = (props: IPreviewProps) => (
  <PortraitTextAndImage {...props} reverse={false} />
);

const PortraitTextAndImageReverse = (props: IPreviewProps) => (
  <PortraitTextAndImage {...props} reverse={true} />
);

const PortraitPreviews = [
  PortraitImage, // FullscreenImage
  PortraitImage, // FullscreenVideo
  PortraitText, // Text
  PortraitTextAndImageForward, // Text & Image 1
  PortraitTextAndImageReverse, // Text & Image 2
  PortraitTextAndImageForward, // Text & Video 1
  PortraitTextAndImageReverse, // Text & Video 2
];

const PreviewPortrait = ({ itemData }: IPreviewProps) => {
  const Preview = PortraitPreviews[itemData.templateType] || null;
  return (
    <div className="relative w-[180px] h-[320px]">
      {Preview ? (
        <Preview itemData={itemData} />
      ) : (
        <DivWFHF className="text-center grid content-center text-darkGrayBg">
          Preview unavailable
        </DivWFHF>
      )}
      <div className="absolute top-0 left-0 w-full h-full">
        <Border />
      </div>
    </div>
  );
};

export { PreviewPortrait };
